// aws-sdk requires global to exist
(window as any).global = window;
